export default __webpack_public_path__ + "static/media/Clock_Hand_Sec.a3382750.svg";